import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'user-picker-next.placeholder',
		defaultMessage: 'Choose people',
		description: 'User picker placeholder message',
	},
	noUsersFound: {
		id: 'user-picker-next.no-users-found',
		defaultMessage: 'We couldn’t find any people.',
		description:
			'Message in the user picker dropdown to indicate that no users were found when searching',
	},
	error: {
		id: 'user-picker-next.error',
		defaultMessage: 'Something went wrong. Try again.',
		description: 'Error message when the user-picker fails to load the list of users',
	},
	addMoreMessage: {
		id: 'user-picker-next.add-more-message',
		defaultMessage: 'Add more people',
		description: 'Message to encourage the user to add more items to user picker',
	},
});
